import React, { useRef, useState, FC, useEffect } from 'react'
import { CanvasPanel, CanvasInstance } from 'bxl-craft'
import { Modal } from 'antd'
import Header, { ISize } from '../header'
import styles from './editormodal.module.scss'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { getAuthHeaders } from '@/utils/session'

interface EdtorModalProps {
  contentUrl: string
  visible: boolean
  onCancel: () => void
  onChange: (svg: string, json: string) => void
}

const EdtorModal: FC<EdtorModalProps> = ({ visible, onCancel, onChange, contentUrl }) => {
  const canvasRef = useRef<CanvasInstance>(null)
  const { i18n } = useTranslation()
  const [size, setSize] = useState({ width: 702, height: 260 })
  const [json, setJson] = useState()
  const onOkHandler = () => {
    onChange(canvasRef.current?.toSVG() || '', canvasRef.current?.toJSON() || '')
  }

  const language = i18n.language?.includes('zh') ? 'zh' : 'en'

  const onSizeChange = (size: ISize) => {
    setSize({ ...size })
  }

  const onImportTemplate = () => {}
  useEffect(() => {
    if (visible && contentUrl) {
      axios.get(contentUrl).then(({ data }) => {
        if (data) {
          setSize({
            width: data.originWidth,
            height: data.originHeight,
          })
          setJson(data)
        }
      })
    }
  }, [visible, contentUrl])

  const getUploadConfig = () => {
    return {
      headers: getAuthHeaders() as Record<string, string>,
    }
  }
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      onOk={onOkHandler}
      width="100%"
      zIndex={10000}
      title={null}
      closable={false}
      bodyStyle={{ padding: 0 }}
      wrapClassName={styles['modal-wrapper']}
      centered
      maskClosable={false}
      destroyOnClose
    >
      <Header
        initialValues={{ size }}
        onSizeChange={onSizeChange}
        onImportTemplate={onImportTemplate}
      />
      <CanvasPanel
        ref={canvasRef}
        {...size}
        style={{ height: 'calc(100vh - 92px)' }}
        json={json}
        initialSetting={{ getUploadConfig }}
        language={language}
      />
    </Modal>
  )
}

export default EdtorModal
